export const obfuscatePhoneNumber = (phoneNumber: string) => {
  const phoneMatch = phoneNumber.match(/^\+?\d{3}(\d+)\d{2}$/)?.[1];
  return phoneMatch
    ? phoneNumber.replace(phoneMatch, '*'.repeat(phoneMatch.length))
    : phoneNumber;
};

export const obfuscateEmail = (email: string) => {
  return email.replace(
    /([a-zA-Z0-9]{2})[a-zA-Z0-9.\-+_$]+@([a-zA-Z0-9]{2})[a-zA-Z0-9.\-+_]+\.([a-zA-Z0-9]+)/,
    '$1***@$2***.$3',
  );
};
